<template>
    <div>
        <el-menu class="navbar" mode="horizontal">
            <hamburger
                :isActive="sidebar.opened"
                :toggleClick="toggleSideBar"
                class="hamburger-container"
            ></hamburger>
            <levelbar></levelbar>
            <el-dropdown class="avatar-container" trigger="click" @command="handleCommand">
                <div class="avatar-wrapper">
                    <img :src="img_user" class="user-avatar" style="display:block"/>
                    <span class="user-name">{{ name || username }}</span>
                    <!-- <i class="el-icon-caret-bottom"></i> -->
                </div>
                <el-dropdown-menu slot="dropdown" class="user-dropdown">
                    <el-dropdown-item command="changePassword">
                        <span>{{$t('login.name8')}}</span>
                    </el-dropdown-item>
                    <el-dropdown-item command="logout" divided>
                        <span>{{$t('login.name9')}}</span>
                    </el-dropdown-item>
                </el-dropdown-menu>
            </el-dropdown>
            <el-dropdown class="avatar-container-logout" trigger="click" @command="logout">
                <div class="avatar-wrapper">
                    <div class="exit" @click="logout">
                        <icon-svg icon-class="tuichu"/>
                    </div>
                </div>
                <el-dropdown-menu>
                    <el-dropdown-item></el-dropdown-item>
                </el-dropdown-menu>
            </el-dropdown>
        </el-menu>
        <change-password-dialog
            :must="must"
            :isshow="dialogChangePasswordFormVisible"
            v-on:close="dialogChangePasswordFormVisible=false"
        ></change-password-dialog>
    </div>
</template>

<script>
import {mapGetters} from "vuex";
import TabsView from "./TabsView";
import Levelbar from "./Levelbar";
import Hamburger from "@/components/Hamburger";
import changePasswordDialog from "../components/changePassword";
import img_user from "@/assets/imgs/user.png";
import img_logout from "@/assets/imgs/logout.png";

export default {
    components: {
        Levelbar,
        Hamburger,
        TabsView,
        changePasswordDialog
    },
    data() {
        return {
            img_user,
            img_logout,
            dialogChangePasswordFormVisible: false,
            must:false,
        };
    },
    computed: {
        ...mapGetters(["sidebar", "name", "username", "avatar"])
    },
    methods: {
        handleCommand(command) {
            switch (command) {
                case "changePassword":
                    this.showDialog();
                    break;
                case "logout":
                    this.logout();
                    break;
            }
        },
        showDialog() {
            this.must=false;
            this.dialogChangePasswordFormVisible = true;
        },
        toggleSideBar() {
            this.$store.dispatch("ToggleSideBar");
            // location.reload();
        },
        logout() {
            this.$store.dispatch("LogOut").then(() => {
                location.reload(); // 为了重新实例化vue-router对象 避免bug
            });
        }
    }
};
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
.navbar {
    height: 50px;
    line-height: 50px;
    border-radius: 0px !important;

    .hamburger-container {
        line-height: 58px;
        height: 50px;
        float: left;
        padding: 0 10px;
    }

    .errLog-container {
        display: inline-block;
        position: absolute;
        right: 150px;
    }

    .screenfull {
        position: absolute;
        right: 90px;
        top: 16px;
        color: red;
    }

    .avatar-container {
        height: 50px;
        display: inline-block;
        position: absolute;
        right: 70px;

        .avatar-wrapper {
            cursor: pointer;
            margin-top: 2px;
            position: relative;
            line-height: 0 !important;

            .user-avatar {
                width: 30px;
                height: 30px;
                text-align: center;
                margin: 0 auto;
                border-radius: 10px;
            }

            .el-icon-caret-bottom {
                position: absolute;
                right: -20px;
                top: 25px;
                font-size: 12px;
            }

            .user-name {
                display: block;
                text-align: center;
                margin: 0 auto;
                font-size: 12px;
                padding-top: 10px;
            }
        }
    }

    .avatar-container-logout {
        height: 50px;
        display: inline-block;
        position: absolute;
        right: 0;

        .avatar-wrapper {
            cursor: pointer;
            // margin-top: 2px;
            position: relative;
            line-height: 0 !important;

            .logout-avatar {
                width: 30px;
                height: 30px;
                text-align: center;
                margin: 0 auto;
                border-radius: 10px;
            }

            .el-icon-caret-bottom {
                position: absolute;
                right: -20px;
                top: 25px;
                font-size: 12px;
            }

            .user-name {
                display: block;
                text-align: center;
                margin: 0 auto;
                font-size: 12px;
                padding-top: 10px;
            }
        }
    }
}

.exit {
    background: #dce6ec;
    width: 50px;
    height: 50px;
    font-size: 24px;
    display: flex;
    justify-content: center;
    align-items: center;
}
</style>






// WEBPACK FOOTER //
// Navbar.vue?20b4ec8b